import { createContext, useContext, type ReactNode } from 'react';
import type { VariantContent } from '../data/types';
import { cyberdogContent } from '../data/cyberdog';
import { therapyContent } from '../data/therapy';

const VariantContext = createContext<VariantContent>(cyberdogContent);

function detectVariant(): VariantContent {
  if (typeof window !== 'undefined' && window.location.pathname.startsWith('/therapy')) {
    return therapyContent;
  }
  return cyberdogContent;
}

export function VariantProvider({ children }: { children: ReactNode }) {
  const content = detectVariant();
  return (
    <VariantContext.Provider value={content}>
      {children}
    </VariantContext.Provider>
  );
}

export function useVariant() {
  return useContext(VariantContext);
}
